// src/Footer.js
import React from 'react';
import { useLanguage } from './LanguageContext';
import Logo from './photos/L.png';
import whats from './photos/whatsapp (1).png';
import tik from './photos/tiktok.png';
import face from './photos/facebook.png';
import insta from './photos/instagram.png';
import './Footer.css'

function Footer() {
  const { language, translations } = useLanguage(); // Access language and translations

  return (
    <footer className="footer">
      <div className="footer-left">
        <img src={Logo} alt="Logo" className="footer-logo" />
      </div>
      <div className="footer-center">
        <div className="footer-links">
          <ul>
            <li><a href="#Hizmetler">{translations[language].services}</a></li>
            <li><a href="#Hakkimizda">{translations[language].aboutUs}</a></li>
            <li><a href="#iletisim">{translations[language].contact}</a></li>
            <li><a href="#Galeri">{translations[language].gallery}</a></li>
          </ul>
        </div>
        <div className="footer-social">
          <a href="https://www.facebook.com/people/Saat%C3%A7i-dental-clinics/61572184035125/"><img src={face} alt="Facebook" /></a>
          {/*<a href="#"><img src={tik} alt="TikTok" /></a>*/}
          <a href="https://www.instagram.com/saatcidentalclinic/"><img src={insta} alt="Instagram" /></a>
          <a href="https://wa.me/905387017377"><img src={whats} alt="WhatsApp" /></a>
        </div>
      </div>
      <div className="footer-right">
        <p>0216 771 72 10</p>
        <p>info@saatcidentalclinics.com</p>
        <p>Bağlarbaşı mahallesi Feyzullah caddesi No: 10/A - Maltepe İstanbul</p>
      </div>
    </footer>
  );
}

export default Footer;
